import { FC, useEffect, useState } from "react";
import "./PaymentHistoryScreen.css";
import backIcon from "../../assets/images/back-icon.svg";
import filterIcon from "../../assets/images/payment-history-filter-icon.svg";
import calendarIcon from "../../assets/images/payment-history-calendar-icon.svg";
import downloadIcon from "../../assets/images/payment-history-download-icon.svg";
import coinIcon from "../../assets/images/credit-paln-coins-icon.svg";
import placeholderGif from "../../assets/gif/app-loader.gif";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import dayjs from "dayjs";
import { DATE_FORMAT } from "utils/constants";
import ROUTE_PATHS from "utils/routePaths";
import PaymentHistoryFilterDialog from "components/elements/PaymentHistoryFilterDialog";
import { STORAGE_KEY } from "utils/strings";

const PaymentHistoryScreen: FC = () => {
  const navigate = useNavigate();
  const { fetchPaymentHistory } = useWSMApi();
  const [showFilterDialog, setShowFilterDialog] = useState<boolean>(false);
  const [paymentType, setPaymentType] = useState<string>("all");

  const { data: paymentData } = useQuery({
    queryKey: ["fetch-payment-history", paymentType],
    queryFn: () =>
      fetchPaymentHistory({
        payment_type: paymentType,
      }),
    retry: false,
  });

  useEffect(() => {
    const storedData = localStorage.getItem("paymentHistoryFilterData");
    if (storedData) {
      setPaymentType(JSON.parse(storedData));
    }
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleFilterClick = () => {
    setShowFilterDialog(true);
  };

  const handlePaymentCardClick = (data: any) => {
    if (!data?.payed_by_credit) {
      localStorage.setItem(
        STORAGE_KEY.SELECTED_PAYMENT_HISTORY_DATA,
        JSON.stringify(data),
      );
      navigate(ROUTE_PATHS.WSM_PAYMENT_HISTORY_DETAIL);
    }
  };

  const handleFilterApply = (filterValue: string) => {
    localStorage.setItem(
      "paymentHistoryFilterData",
      JSON.stringify(filterValue),
    );
    setPaymentType(filterValue);
  };

  return (
    <div className="wms-mobile-container">
      <div className="payment-history-screen-container">
        <div className="payment-history-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="left-container">
            <div className="title">Payment History</div>
            <img
              src={filterIcon}
              alt="filter-icon"
              onClick={handleFilterClick}
            />
          </div>
        </div>
        {paymentData?.data?.content?.length > 0 ? (
          <div className="payment-history-content-container">
            <div className="header-container">
              <span>
                Filtered by :{" "}
                <span style={{ color: "white" }}>{paymentType} mode</span>
              </span>
            </div>
            {paymentData?.data?.content?.map(
              (paymentData: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="payment-history-card-container"
                    onClick={() => handlePaymentCardClick(paymentData)}
                  >
                    <span>{paymentData?.product_name}</span>
                    <div className="detail-conatainer">
                      <div className="left-container">
                        <div className="calendar-conatiner">
                          <img src={calendarIcon} alt="calendar-icon" />
                          <span>
                            <span style={{ color: "#CDD7D6" }}>Date :</span>{" "}
                            {dayjs(paymentData?.created_at).format(DATE_FORMAT)}
                          </span>
                        </div>
                        <div className="download-conatiner">
                          <img
                            src={
                              paymentData?.payed_by_credit
                                ? coinIcon
                                : downloadIcon
                            }
                            alt="download-icon"
                          />
                          {paymentData?.payed_by_credit ? (
                            <span>
                              <span style={{ color: "#C2B58C" }}>
                                Credit Used :
                              </span>{" "}
                              {paymentData?.credit}
                            </span>
                          ) : (
                            <span>
                              <span style={{ color: "#C2B58C" }}>
                                Invoice No :
                              </span>{" "}
                              {paymentData?.payment_id}
                            </span>
                          )}
                        </div>
                      </div>
                      {!paymentData?.payed_by_credit && (
                        <div className="right-container">
                          <button>View More</button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              },
            )}
          </div>
        ) : (
          <div className="payment-history-placeholder-container">
            <img src={placeholderGif} alt="placeholder-icon" />
            <p>You have no payment history.</p>
          </div>
        )}
      </div>
      <PaymentHistoryFilterDialog
        open={showFilterDialog}
        onClose={() => setShowFilterDialog(false)}
        onApply={handleFilterApply}
      />
    </div>
  );
};

export default PaymentHistoryScreen;
